<template>
  <v-card
    class="totalAmount px-2 text-center"
    outlined
    id="amountcard"
    height="92px"
  >
    <v-row no-gutters align="center" class="fill-height">
      <v-col class="pl-1">
        <v-row dense justify="space-between" align="center">
          <v-col cols="10">
            <div class="fs-12 font-weight-700 lh-20 primary--text">
              {{ text }}
            </div>
          </v-col>
        </v-row>
        <v-row dense class="total">
          <v-col cols="10" :class="textColor" class="lh-23">
            {{ currFormatter(value1) || '-' }}
            <span class="curr" :class="textColor">BIDR</span>
          </v-col>
          <v-col
            cols="2"
            class="text-right red--text py-0 title-percent title right-text align-self-center"
            v-if="typeCard !== 1"
          >
            <percentage-spending
              v-if="typeCard === 2"
              :val1="value1"
              :val2="valueTotal"
              class="right-text"
              :class="textColor"
            ></percentage-spending>
            <percentage-remaining
              class="right-text"
              :class="textColor"
              v-if="typeCard === 3"
              :val1="value1"
              :val2="valueTotal"
            ></percentage-remaining>
          </v-col>
        </v-row>
        <v-row dense class="total-eur">
          <v-col cols="10"> {{ eur(valueEur) || '-' }} MEUR </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import PercentageSpending from './percentageSpending';
import PercentageRemaining from './percentageRemaining';

export default {
  components: {
    'percentage-spending': PercentageSpending,
    'percentage-remaining': PercentageRemaining
  },
  props: {
    typeCard: {
      type: Number,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    value1: {
      type: Number,
      required: true
    },
    valueTotal: {
      type: Number,
      required: false
    },
    valueEur: {
      type: Number,
      required: true
    },
    colour: {
      type: String,
      required: true
    },
    textColor: {
      type: String,
      required: true
    }
  }
};
</script>
